import React from 'react';
import DashboardPanel from 'modules/dashboard/components/dashboardPanel';
import DashboardWidget from 'modules/dashboard/components/dashboardWidget';
import { numberOfColumns, rowHeight } from '../../utils/dashboardUtils';
import { StyledGridLayout } from '../Dashboard.styled';

// type Props = {
//   /** Number of columns for the dashboard grid. */
//   cols: number,
//   /** Class name for drag handles. */
//   dragHandleClass?: string,
//   /** If dashboard is currently fetching data. Forces re-render. */
//   isFetching: boolean,
//   /** Array of dashboard panel configs to build layout. */
//   layout: array,
//   /** Amount of pixels between each dashboard panel. [x, y] */
//   margin: array,
//   /** Callback function when widget is deleted. */
//   onDeleteWidget: () => void,
//   /** Callback function when widget is edited. */
//   onEditWidget: () => void,
//   /** Callback function returns layout array when a panel is changed. */
//   onLayoutChange: () => array,
//   /** Allow other panels to move when rearranging a panel, */
//   preventCollision?: boolean,
//   /** Height of row (in pixels) for the dashboard grid. */
//   rowHeight: number,
//   /** Show drag handle and only allow dragging panels on handle. */
//   showDragHandles?: boolean,
//   /** The dashboard theme. */
//   theme: string,
//   /** Toggles compaction to float panels to top or place panels wherever. */
//   verticalCompact?: boolean,
//   /** Dashboard widgets. */
//   widgets: object,
// };

/**
 * Container of DashboardPanels (Containers for DashboardWidgets) and arranges them in grid.
 */
export default class DashboardGrid extends React.Component {
  static defaultProps = {
    cols: numberOfColumns,
    dragHandleClass: 'dragHandle',
    isFetching: true,
    layout: [],
    margin: [20, 20],
    onDeleteWidget: () => {},
    onEditWidget: () => {},
    onLayoutChange: () => {},
    preventCollision: false,
    rowHeight,
    showDragHandles: true,
    verticalCompact: true,
    widgets: {},
  };

  // NOTE: (Changelog)
  // Having this function caused a bug not saving dashboard layout. (01/18/19)
  // Updating to force re-render when dashboard is fetching. Should prevent layout bug and increase performance. (01/29/19)
  /**
   * shouldComponentUpdate
   * Updates dashboard grid when adding or removing a panel.
   * @param { Object } nextProps: Updated props containing new layout.
   * @returns { Boolean } If the dashboard grid should be updated.
   */
  shouldComponentUpdate({ isFetching, layout, theme }) {
    return (
      this.props.layout.length !== layout.length ||
      this.props.theme !== theme ||
      this.props.isFetching !== isFetching
    );
  }

  /**
   * Adds DashboardPanels containing a DashboardWidget to the grid from the given layout array.
   * @returns { Array } Array of DashboardPanels.
   */
  generateDOM = () => {
    const {
      dragHandleClass,
      layout,
      onDeleteWidget,
      onEditWidget,
      showDragHandles,
      theme,
      widgets,
    } = this.props;
    return layout.map((dashboardPanelConfig) => {
      const { i: id } = dashboardPanelConfig;
      return (
        <DashboardPanel
          showDragHandle={showDragHandles}
          dragHandleClass={dragHandleClass}
          key={id}
          data-i={id}
          theme={theme}
          {...dashboardPanelConfig}
        >
          <DashboardWidget
            onClickDelete={onDeleteWidget}
            onClickEdit={onEditWidget}
            id={id}
            theme={theme}
            widget={widgets[id]}
          />
        </DashboardPanel>
      );
    });
  };

  /**
   * Callback when layout changes
   * @param { Array } layout: The layout config array.
   * @return { void }
   */
  handleLayoutChange = (layout) => {
    this.props.onLayoutChange(layout);
  };

  render() {
    const { dragHandleClass, showDragHandles, ...otherProps } = this.props;

    return (
      <StyledGridLayout
        {...otherProps}
        className="cssDashboardGrid"
        draggableHandle={showDragHandles ? `.${dragHandleClass}` : undefined}
        onLayoutChange={this.handleLayoutChange}
      >
        {this.generateDOM()}
      </StyledGridLayout>
    );
  }
}
